import script from "./DocItemUnsupported.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemUnsupported.vue?vue&type=script&setup=true&lang=js"

import "./DocItemUnsupported.vue?vue&type=style&index=0&id=091c12fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091c12fb"]])

export default __exports__